import axios from "axios";
import {baseUrl} from '../common/config.js';
import { axiosCallService } from "../common/apiCallService.js";
const qs = require('querystring');

export const getPlayerTypeList = () => 
    axiosCallService(`/appUser/getPlayerType`)

export const getRolesAndBusiness = () => 
    axiosCallService(`/appUser/getRolesByAccess`,{"userRole": JSON.parse(localStorage.getItem('userRole'))});

export const getUsersList = (data) => 
    axiosCallService(`/appUser/appUserList`, data)

export const getCoachList = (data) => 
    axiosCallService(`/appUser/getCoachList`, data);


/** WEBPACK FOOTER **
 ** ./src/endPoints/appUser.js
 **/